import type { SymbolsState } from '@/features/Dashboard/context/EditChartApp/types';

export const reorderItems = (limit: number, items: SymbolsState): SymbolsState => {
  const mergedItems = [...items.active, ...items.backlog];
  const newActive = mergedItems.slice(0, limit);
  const newBacklog = mergedItems.slice(limit);
  return {
    active: newActive,
    backlog: newBacklog
  };
};
